import {
  SET_DETAILS_USERS,
  SET_PAGINATION_PAGE_USERS,
  SET_PAGINATION_SIZEPERPAGE_USERS,
  SET_DETAILS_ERROR_USERS,
} from '../types';

const initialState = {
  users: [],
  totalSize: 0,
  page: 1,
  sizePerPage: 10,
  error: undefined,
  loading: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DETAILS_USERS:
      return {
        ...state,
        users: action.payload,
        totalSize: action.payload.length,
        loading: false,
      };
    case SET_PAGINATION_PAGE_USERS:
      return {
        ...state,
        page: action.page,
      };
    case SET_PAGINATION_SIZEPERPAGE_USERS:
      return {
        ...state,
        sizePerpage: action.sizePerpage,
      };
    case SET_DETAILS_ERROR_USERS:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
